import { useEffect, useRef } from 'react';

export default function ApproacheSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.approach-animate').forEach((item, i) => {
              setTimeout(() => {
                item.classList.add('animate-fade-up');
                item.classList.remove('opacity-0-init');
              }, i * 150);
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-32 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Approach block */}
        <div className="flex flex-col lg:flex-row lg:items-center gap-12 lg:gap-24 mb-20 md:mb-28">
          <div className="lg:w-2/5">
            <span className="approach-animate opacity-0-init block text-xs font-medium tracking-[0.3em] text-stone-400 uppercase mb-4">Notre approche</span>
            <h2 className="approach-animate opacity-0-init font-serif-display text-5xl md:text-6xl font-bold text-stone-900 leading-tight">
              Approche
            </h2>
          </div>
          <div className="lg:w-3/5">
            <p className="approach-animate opacity-0-init text-lg md:text-xl text-stone-600 leading-[1.9]">
              Chaque projet est réalisé avec attention afin de proposer des solutions claires, fonctionnelles et adaptées à chaque client. Le design graphique au service d&apos;une vision claire et d&apos;une communication efficace.
            </p>
          </div>
        </div>

        {/* Quote block */}
        <div className="border-t border-stone-200 pt-16 md:pt-20 flex flex-col lg:flex-row lg:items-start gap-10 lg:gap-24">
          <div className="lg:w-1/3">
            <span className="approach-animate opacity-0-init text-xs font-medium tracking-[0.3em] text-stone-400 uppercase">
              &bull; Philosophie
            </span>
          </div>
          <div className="lg:w-2/3">
            <blockquote className="approach-animate opacity-0-init">
              <p className="font-serif-display text-3xl md:text-4xl lg:text-5xl font-medium text-stone-900 leading-[1.25] mb-8">
                &ldquo;Des solutions simples, efficaces et adaptées à chaque client.&rdquo;
              </p>
              <footer className="flex items-center gap-3">
                <span className="text-sm font-semibold text-stone-900">Dawid Kurta</span>
                <span className="text-xs text-stone-400 bg-stone-100 px-3 py-1 rounded-full">Bordeaux</span>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}